module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.63d2a595.woff";